import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Flame } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { bbFetch, LEVEL_META, LevelBadge, fmtDate } from './bbShared';

export const SimulationBridge = ({ simulationId }) => {
  const { token } = useAuth();
  const [info, setInfo] = useState(null);
  const load = useCallback(() => bbFetch(token, `/bb/simulation/${simulationId}`).then(setInfo).catch(() => setInfo(null)), [token, simulationId]);
  useEffect(() => { if (token && simulationId) load(); }, [load, token, simulationId]);
  if (!info) return null;
  const d = info.dossier;
  const temp = info.simulation.temperature;

  if (d) {
    return (
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl px-4 py-3" style={{ background: '#FBEFD5' }} data-testid="bb-bridge-banner">
        <div>
          <p className="text-sm font-bold text-[#7A4F0E] flex items-center gap-1.5"><Flame className="w-4 h-4" />Dans le Business Commercial · {LEVEL_META[d.niveau]?.label}{d.besoin_aide ? " · besoin d'aide" : ''}</p>
          <p className="text-xs text-[#7A4F0E]/80">Signature estimée le {fmtDate(info.simulation.date_signature_estimee || d.date_signature_visee)}</p>
        </div>
        <Link to={`/business-bouillant/${d.id}`} className="text-sm font-bold text-[#1B1C1F] hover:underline" data-testid="bb-bridge-open">Voir le dossier</Link>
      </div>
    );
  }
  if (!temp) return null;
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="bb-bridge">
      <span className="text-xs text-slate-500 flex items-center gap-1.5">Température : <LevelBadge level={temp} testId="bb-bridge-temp" /></span>
    </div>
  );
};
